import { menuData } from '@/data/menu';
import styles from './MenuPage.module.css';

function DraftsPage() {
  const drafts = menuData.categories.drafts;

  return (
    <div className={styles.page}>
      <section className={styles.category}>
        <h2 className={styles.categoryTitle}>Drafts</h2>
        {drafts.description && (
          <p className={styles.categoryDescription}>{drafts.description}</p>
        )}
        <div className={styles.itemsGrid}>
          {drafts.items.map((item) => (
            <div key={item.name} className={styles.menuItem}>
              <table className={styles.itemTable}>
                <tbody>
                  <tr>
                    <td className={styles.itemName}>{item.name}</td>
                    <td className={styles.itemPrice}>
                      {item.price > 0 ? `${item.price.toFixed(2)}` : ''}
                    </td>
                  </tr>
                </tbody>
              </table>
              {item.description && (
                <p className={styles.itemDescription}>{item.description}</p>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default DraftsPage;
